import React, {useEffect, useState} from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";
import { FloatingContinueBtn } from "../../../../../components/FloatingContinueBtn";
import { isValidEmail } from "../../../../../utils/common";
import { getUsersChosenUsLabel } from "../../../../../const/SocialProof";

export const MobileEmail = ({setEmail, email, onPageFocus, onPageKeyDown, isCurPage, inputRef, clickNext}) => {

  // 控制浮动按钮显示
  const [showFloatingBtn, setShowFloatingBtn] = useState(false);
  
  // 处理输入框聚焦
  const handleFocus = (e) => {
    setShowFloatingBtn(true);
    if (onPageFocus) onPageFocus(e);
  };
  
  // 处理输入框失焦
  const handleBlur = () => {
    setTimeout(() => {
      setShowFloatingBtn(false);
    }, 200);
  };
  
  // 处理浮动按钮点击
  const handleFloatingBtnClick = () => {
    if (isValidEmail(email)) {
      // 隐藏键盘
      if (inputRef.current) inputRef.current.blur();
      setShowFloatingBtn(false);
      // 触发提交
      if (clickNext) clickNext(email);
    }
  };

  return (
    <div className="email-mobile" data-model-id="16761:2824">
      <FloatingContinueBtn 
        show={showFloatingBtn} 
        allow={isValidEmail(email)}
        onClick={handleFloatingBtnClick}
      />
      <div className="email-div">
        <div className="title">
          <p className="heading">
            Enter your email to get your personal weight loss plan
          </p>
        </div>

        <div className="frame-2">
          <div className="list">
            <div className="date-picker">
              <input ref={inputRef} className="email-input"
                     readOnly={!isCurPage}
                     enterKeyHint="done"
                     type={"email"}
                     placeholder={"Enter your email to get your plan"}
                     onFocus={handleFocus}
                     onBlur={handleBlur}
                     onKeyDown={onPageKeyDown}
                     onChange={(e) => { setEmail(e.target.value)}} value={email}
              />
            </div>
          </div>

          <div className="discount">
            <Image src="/static/image/questionnaire/weight-loss/email/icon.png" alt="Icon" className="img" />

            <p className="user-count">{getUsersChosenUsLabel()}</p>
          </div>

          <div className="email-privacy">
            <Image src="/static/image/questionnaire/weight-loss/email/lock.png" alt="Lock" className="lock" />

            <p className="privacy-statement">
              We respect your privacy and are committed to protecting your
              personal data. We&#39;ll email you a copy of your results for
              convenient access.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
